import type { ReactNode } from 'react'

import { Card, CardBody, CardHeader } from '@/src/elements/card'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'

import { SettingsCardSwitchInput } from '../SettingsCardSwitchInput'
import { SettingsCardGeneralPushSwitch } from './SettingsCardGeneralPushSwitch'

export type TSettingsCardGeneralBaseProps = {
  title?: string
  isMailEnabled?: boolean
  isPushEnabled?: boolean
  mailDisabled?: boolean
  pushDisabled?: boolean
  onMailChange: (value: boolean) => Promise<void> | void
  onPushChange?: (value: boolean) => Promise<void> | void
  testID?: string
}

export const SettingsCardGeneralBase = ({
  title,
  isMailEnabled,
  isPushEnabled,
  mailDisabled,
  pushDisabled,
  onMailChange,
  onPushChange,
  testID,
}: TSettingsCardGeneralBaseProps): ReactNode => (
  <Card testID={testID} className="gap-2 p-3">
    <CardHeader className="flex flex-col gap-1 p-1">
      {title && (
        <Typography bold ariaRole="span">
          {title}
        </Typography>
      )}
    </CardHeader>

    <CardBody className="flex flex-col gap-1 p-1">
      <SettingsCardSwitchInput.Mail
        testID={TEST_ID.SETTINGS.COMPONENTS.CARD_GENERAL_SWITCH_INPUT.MAIL}
        value={isMailEnabled}
        onValueChange={onMailChange}
        disabled={mailDisabled}
      />
      {onPushChange && (
        <SettingsCardGeneralPushSwitch push={isPushEnabled} pushDisabled={pushDisabled} onPushChange={onPushChange} />
      )}
    </CardBody>
  </Card>
)
